import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'password',
        name: 'password',
        is: 'passwordAgain',
        title: i18n.t('user.form.password'),
        rules: {required: true, min: 3},
        options: false,
        modal: ['new_pass'],
        data: ['new_pass'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'password',
        name: 'passwordAgain',
        is: 'password',
        title: i18n.t('user.form.passwordAgain'),
        rules: {required: true, min: 3, is:'password'},
        options: false,
        modal: ['new_pass_retry'],
        data: ['new_pass_retry'],
        additionalButton: false,
        checkBox: false
    }
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/General/Users/forms/changeDefaultForm.js